import React, { useState } from "react";
import SingleSelectButtonGroupWithOther from "../components/BrandsPartnerComponents/single_select_button_group_with_other";
import MultiSelectCheckboxGroup from "../components/BrandsPartnerComponents/multiselect_checkbox";
import { PartnerType } from "./dtos/partner.dtos";
import MultiSelectWithAddItem from "../components/BrandsPartnerComponents/MultiselectComponentWithAddItem";
import { usePartnerOnboarding } from "../../contexts/PartnerOnboardingContext";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";

type GrowingTogetherPageType = {
  data: PartnerType;
  setData: React.Dispatch<React.SetStateAction<PartnerType>>;
  isMobile?: boolean;
  previousStep: () => void;
  nextStep: () => void;
};

const GrowingTogetherPage: React.FC<GrowingTogetherPageType> = ({
  data,
  setData,previousStep,
  nextStep,isMobile
}) => {
  const valueAddedServices = ["None",
    "Brand Sourcing",
    "Develop Inhouse Brands",
    "Expand Existing Brands to New Markets",
    // "Other",
  ];

  const options = ["None",
    "Financing (eg:Inventory)",
    "Capital (Equity/Debt)",
   
   
  ];

  const [selectedVAS, setSelectedVAS] = useState<string[]>([]);
  const [selectedFinancialAssistance, setSelectedFinancialAssistance] =
    useState<string[]>([]);
  const [checkedVAS, setCheckedVAS] = useState(true);
  const [checkedFin, setCheckedFin] = useState(true);
  const { customOptionsMap, setCustomOptionsMap } = usePartnerOnboarding();
  const [otherInputValue, setOtherInputValue] = useState("");
  const [otherInputValueFin, setOtherInputValueFin] = useState("");
  const toggleSelectionVAS = (option: any) => {
    if (selectedVAS.includes(option)) {
      setSelectedVAS(selectedVAS.filter((item) => item !== option));
    } else {
      setSelectedVAS([...selectedVAS, option]);
    }
  };
  const toggleSelectionFin = (option: any) => {
    if (selectedFinancialAssistance.includes(option)) {
      setSelectedFinancialAssistance(
        selectedFinancialAssistance.filter((item) => item !== option)
      );
    } else {
      setSelectedFinancialAssistance([...selectedFinancialAssistance, option]);
    }
  };
  const [validationError, setValidationError] = useState<{ [key: string]: string }>({});


  const handleNext = () => {
    let errorMessage: { [key: string]: string } = {};
   const vatLen= data.value_added_services.length;
   const finLen= data.financial_assistance.length;
        // Check for Focus Categories
        if (vatLen === 0) {
            errorMessage.vat=( "Please select at least one item in Value added services ");
        }

        // Check for Channel Capabilities
        if (finLen === 0) {
            errorMessage.fin=("Please select at least one item in Financial Assistance. ");
        }
       

        // Set validation error or proceed
        if  (Object.keys(errorMessage).length > 0)  {
            setValidationError(errorMessage);
            console.log("error !"); // Show the error messages
        } else {
            console.log("Valid selection!");
            nextStep(); // Proceed to next step if valid
            setValidationError({}); // Clear any previous error
        }
    
};

  return (
    <div className="w-full max-w-[686px]">
      <div className="common-title pb-[12px]">Growing Together</div>
      <div className="common-sub-text pb-[60px]">
        We want to support your business. What kind of assistance do you need?
      
      </div>
    
      {/*Form */}
      <div className="flex flex-col gap-y-[32px]">
        {/* Value Added Services  */}
        <MultiSelectWithAddItem
        customOptionsMap={customOptionsMap}
        setCustomOptionsMap={setCustomOptionsMap}
        error={validationError.vat}
        activeMarket={''}
          label="Value Added Services"
           contextKey="valueAddedServices"
          checked={checkedVAS}
          showCheckBox={false}
          options={valueAddedServices}
          selected={data.value_added_services}
          setChecked={setCheckedVAS}
          showAddCustom
          setSelected={(e) =>
            setData((current) => ({
              ...current,
              value_added_services: e,
            }))
          }
          otherInputValue={otherInputValue}
          setOtherInputValue={setOtherInputValue}
        />

        {/* Financial Assistance*/}
        <MultiSelectWithAddItem
        customOptionsMap={customOptionsMap}
        setCustomOptionsMap={setCustomOptionsMap}
        error={validationError.fin}
        activeMarket={''} 
          label="Financial Assistance"
           contextKey="financialAssistance"
          checked={checkedFin}
          showCheckBox={false}
          options={options}
          selected={data.financial_assistance}
          setChecked={setCheckedFin}
          showAddCustom
          setSelected={(e) =>
            setData((current) => ({
              ...current,
              financial_assistance: e,
            }))
          }
          otherInputValue={otherInputValueFin}
          setOtherInputValue={setOtherInputValueFin}
        />
        {/* <MultiSelectCheckboxGroup
          showCheckBox={false}
          label="Financial Assistance"
          options={options}
          selected={selectedFinancialAssistance}
          setSelected={setSelectedFinancialAssistance}
          otherInputValue={otherInputValueFin}
          setOtherInputValue={setOtherInputValueFin}
          checked={checkedFin}
          setChecked={setCheckedFin}
          toggleSelection={toggleSelectionFin}

        /> */}
      </div>
         {/* Desktop Next/Previous Navigation */}
         {!isMobile && (
        <div
          className="mt-[60px]   inline-flex flex justify-start gap-x-[8px] w-full md:w-auto"
        >

          <NavigationButton
            onClick={previousStep}
            label="Previous"
            type="text"
          />

          <NavigationButton
             onClick={handleNext}
            label={"Submit"}
            type="primary"
          />
        </div>
      )}

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <div className="fixed bottom-0 left-0 right-0 flex justify-center px-4 py-4 gap-x-2 w-full shadow-lg z-20 bg-white">
          {(
            <NavigationButton
              onClick={previousStep}
              label="Previous"
              type="text"
              block
            />
          )}
          <NavigationButton
           onClick={handleNext}
            label={"Submit"}
            type="primary"
            block
          />
        </div>
      )}

    </div>
  );
};

export default GrowingTogetherPage;
